import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { v4 as uuid } from 'uuid';
import cns from 'classnames';
import BasicText from '../../../../../../shared/components/formComponents/groups/BasicText';
import RawImageUpload from '../../../../../../shared/components/formComponents/inputs/RawImageUpload';
import VerbButton, { VERB_BUTTON_TYPE } from '../../../../../../shared/components/VerbButton';

export default class CategoriesFieldArray extends Component {
    static propTypes = {
        fields: PropTypes.object.isRequired,
        displayType: PropTypes.any,
        disabled: PropTypes.bool
    };

    constructor(props) {
        super(props);

        this.state = {
            hiddenCategories: []
        };
    }

    render() {
        const { fields, displayType, disabled } = this.props;
        const { hiddenCategories } = this.state;

        let table;
        if (fields && fields.length > 0) {
            table = (
                <div className={'row category-table'}>
                    {fields.map((category, index) => (
                        <div className={'col-12'}>
                            <div className={'row'}>
                                {!hiddenCategories.includes(index) ? (
                                    <div className={'col-12'}>
                                        <div className={'row'}>
                                            <Field
                                                component={RawImageUpload}
                                                className={'col-3'}
                                                disableStyle={true}
                                                name={`${category}.image`}
                                                label={'Image'}
                                                disabled={disabled}
                                            />
                                            <div className={'col-9'}>
                                                <div className={'row'}>
                                                    <Field
                                                        name={`${category}.name`}
                                                        className={'col-6'}
                                                        label={'Name'}
                                                        component={BasicText}
                                                        disabled={disabled}
                                                    />
                                                    <Field
                                                        name={`${category}.description`}
                                                        className={'col-6'}
                                                        label={'Description'}
                                                        disabled={disabled}
                                                        component={BasicText}
                                                    />
                                                    <div className={cns('col-12 buttonCell')} hidden={disabled}>
                                                        <VerbButton
                                                            title={'Remove Category'}
                                                            buttonText={'Remove Category'}
                                                            fontAwesomeIcon={'fa-trash-alt'}
                                                            onClick={() => fields.remove(index)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    ))}
                </div>
            );
        }

        return (
            <div>
                {displayType ? (
                    <div className={'permutationSectionCategories'}>
                        <h4 className={'col-12'}>CATEGORIES</h4>
                        <VerbButton
                            title={'Toggle Visibility All Categories'}
                            className={'collapse-expand-btn'}
                            buttonType={VERB_BUTTON_TYPE.SECONDARY_DEFAULT}
                            fontAwesomeIcon={
                                hiddenCategories.length === fields.length ? 'fa-caret-down' : 'fa-caret-up'
                            }
                            buttonText={hiddenCategories.length === fields.length ? 'Expand' : 'Collapse'}
                            onClick={() =>
                                hiddenCategories.length === fields.length
                                    ? this.setState({ hiddenCategories: [] })
                                    : this.setState({ hiddenCategories: fields.map((_, i) => i) })
                            }
                        />
                        {table}
                        <VerbButton
                            className={cns('permutationSectionCategoriesButton', { hidden: disabled })}
                            onClick={() => fields.push({ id: uuid(), name: null, description: null, image: null })}
                            fontAwesomeIcon={'fa-plus'}
                            buttonText={'Add Category'}
                        />
                    </div>
                ) : null}
            </div>
        );
    }
}
